import gql from 'graphql-tag'

const AllUsers = gql`
  query UsersConnection($autoComplete: UserAutoComplete) {
    usersConnection(autoComplete: $autoComplete) {
      edges {
        cursor
        node {
          id
          name
          surname
        }
      }
    }
  }
`

export { AllUsers }



// WEBPACK FOOTER //
// ./src/queries/AllUsers.js